module.exports = __webpack_public_path__ + "static/media/IMG_0251.e3a83a5b.jpg";